module.exports = __webpack_public_path__ + "static/media/banner_contato.a8eeddec.jpg";